export default "__VITE_ASSET__DN$1bbCZ__"